/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = ["@media screen and (max-width:599px){.phone-number-dialog{width:80vh}}@media screen and (min-width:600px){.phone-number-dialog{width:80vh}}@media screen and (min-width:1280px){.phone-number-dialog{width:600px}}.phone-number-dialog .mat-dialog-container{padding:0}.phone-number-dialog .mat-dialog-container .mat-toolbar{flex:1 0 auto;min-height:initial}.phone-number-dialog .mat-dialog-container .toolbar-bottom{height:auto}.phone-number-dialog .mat-dialog-content{max-height:85vh;margin:0;padding:0}.phone-number-dialog .mh-30-vh{min-height:30vh}"];
export { styles as styles };
